<script>
    import CaretDown from "phosphor-svelte/lib/CaretDown";
    import CaretUp from "phosphor-svelte/lib/CaretUp";

    export let step;
    export let type;
    export let value;

    const increment = (step) => value += step;

    const typeClasses = {
        up: 'rounded-tr-lg border-b',
        down: 'rounded-br-lg',
    }
</script>

<button
    on:click={() => increment(step)}
    type="button"
    class="border-l border-gray-900 hover:bg-gray-700 active:text-white text-emerald-500 active:bg-emerald-500  border-0 flex-1 w-10 flex items-center justify-center {typeClasses[type]}"
>
    <svelte:component
        this={type === 'up' ? CaretUp : CaretDown}
        class="text-xl"
    />
</button>